import { Card, Grid, pn, Stack, Typography, useElementBreakpoints, ValidationErrors } from "@compass/core";
import { DatePicker, Select } from "components";
import { AprRequest, AprRequestFilter, AprResource, LkStudentDisplayFieldId } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const AprUbFilters = (props: {
  filter: AprRequestFilter;
  setFilter: (value: AprRequestFilter) => void;
  resource: AprResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties =
    props.resource.properties?.find((x) => x.propertyName === pn<AprRequest>("filter"))?.children || [];

  const schoolYearField = () => {
    const propertyName = pn<AprRequestFilter>("schoolYear");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.resource.schoolYears?.find((x) => x.id === props.filter.schoolYear)}
        options={props.resource.schoolYears}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.schoolYear = value?.id;
            })
          )
        }
      />
    );
  };

  const programField = () => {
    const propertyName = pn<AprRequestFilter>("programId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.resource.programs?.find((x) => x.id === props.filter.programId)}
        options={props.resource.programs}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.programId = value?.id;
            })
          )
        }
      />
    );
  };


  return (
    <Card>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          {schoolYearField()}
        </Grid>

        {props.resource.displayFields?.find((x) => x.id === LkStudentDisplayFieldId.Program) && (
          <Grid item xs={smallFieldBreakpoints}>
            {programField()}
          </Grid>
        )}
      </Grid>
    </Card>
  );
};
